<template>
  <v-container fluid style="height: 100%">
    <simple-history :histories="histories" :functionCategory="functionCategory"></simple-history>
  </v-container>
</template>

<script>
import SimpleHistory from "../common/SimpleHistory.vue";
import { statuses as ApiStatus } from "../../libs/api-client";
export default {
  name: "OrderHistory",
  props: ["orderId", "isAchievementMode"],
  components: {
    SimpleHistory,
  },
  data() {
    return {
      histories: {},
      functionCategory: "",
    };
  },
  watch: {
    orderId(orderId) {
      this.init(orderId);
    },
  },
  mounted() {
    this.init(this.orderId);
  },
  methods: {
    async init(orderId) {
      try {
        this.loadingOn();
        this.functionCategory = "order";
        var url = this.isVendorUser && this.isAchievementMode ? "order/ordersshippedHistory" : "order/history";
        const response = await this.$store.dispatch(url, { orderId: orderId });
        if (ApiStatus.isSystemError(response.data?.header)) {
          return this.redirectError();
        }
        this.histories = response.data.contents.histories;
      } catch (error) {
        console.error("OrderHistory::mounted", error);
      } finally {
        this.loadingOff();
      }
    },
  },
};
</script>
